import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import {
  Row,
  Col,
  Card,
  Tooltip,
  Input,
  Checkbox,
  message,
  Spin,
  Collapse,
  Modal,
  Switch,
  Tree,
} from "antd";
import { CSVLink } from "react-csv";
import { useNavigate } from "react-router-dom";
import { CALL_API } from "../../../Common/api";
import UIModal from "../../../Reusablecomponents/UIModal";
import { ReactComponent as Icon } from "../../../../src/assets/images/kpm.svg";
import { ReactComponent as GConfig } from "../../../../src/assets/images/GConfig.svg";
import { ReactComponent as GCopy } from "../../../../src/assets/images/GCopy.svg";
import { ReactComponent as GSync } from "../../../../src/assets/images/GSync.svg";
import { ReactComponent as GDelete } from "../../../../src/assets/images/GDelete.svg";
import GSort from "../../../../src/assets/images/GSort.svg";
import { ReactComponent as GeoDelete } from "../../../../src/assets/images/GeoDelete.svg";
import { ReactComponent as GExport } from "../../../../src/assets/images/GExport.svg";
import { ReactComponent as GKPM } from "../../../../src/assets/images/GKPM.svg";
import { ReactComponent as Drop } from "../../../../src/assets/images/drop.svg";
import { ReactComponent as GArrow } from "../../../../src/assets/images/GArrow.svg";
import Styled from "styled-components";
import dayjs from "dayjs";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../../Reusablecomponents/UIButtons";
import { useDispatch, useSelector } from "react-redux";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { ReactComponent as IntelSearch } from "../../../../src/assets/images/Frame 1233.svg";
import { FENCE_TYPE_LABELS } from "../../../Reusablecomponents/fenceStyleConstants";
import { TRAKING_API_BASE } from "../../../Common/traking";

dayjs.extend(utc);
dayjs.extend(timezone);

const Styledashboard = Styled.div`
.title {
font-weight: 600;
font-style: Semi Bold;
font-size: 18px;
color: #3D3D3D;
height: 17px;
width: 190px;
margin-top: 6px;
}
.container_for_header_subtwo {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap; /* allows wrapping instead of shrinking */
}
  .select_icon_dropdown {
  flex: 1;          /* expand to take leftover space */
  max-width: 350px; /* but not beyond */
  min-width: 200px; /* keep it usable */
}
.container_for_header_subtwo > *:not(.select_icon_dropdown) {
  flex-shrink: 0; /* icons won't shrink */
}

    /* Style only the icon/button on the right */
  .green-search-icon .ant-input-search-button {
    background: #06ce06 !important;
    border-color: #06ce06 !important;
    color: white !important;
  }

  /* Make hover consistent */
  .green-search-icon .ant-input-search-button:hover {
    background: #05b605 !important;
    border-color: #05b605 !important;
  }
  /* Remove unwanted spacing before prefix icon */
  .custom-search .ant-input-prefix {
    margin-right: 6px !important; /* Keep small gap between icon & text */
    margin-left: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-left: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  /* Remove internal padding on input caused by prefix */
  .custom-search.ant-input-affix-wrapper {
    padding-left: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #00bc13 !important;
  border-color: #00bc13 !important;
}
.ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: #00bc13 !important;
}
.container_scrollable{
  height : calc(100vh - 140px) !important;
  overflow-y: scroll !important;
}
.scrollablle_container_two{
  height : calc(100vh - 340px) !important;
  overflow-y: scroll !important;
}
  `;
const { Panel } = Collapse;
const { Search } = Input;
const { TextArea } = Input;
const NexusGeoFence = () => {
  const navigate = useNavigate();
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [companyList, setCompanyList] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectedFences, setSelectedFences] = useState([]);
  const [fenceList, setFenceList] = useState([]);
  const [copyTargetAgent, setCopyTargetAgent] = useState({
    guid: null,
    name: "",
    type: null,
  });
  const [sortFields, setSortFields] = useState([]);
  const [agentCopy, setAgentCopy] = useState([]); // array of selected node IDs
  const [selectedAgent, setSelectedAgent] = useState({
    company_id: "all",
    company_name: "All Companies",
  });
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isCopyModalVisible, setIsCopyModalVisible] = useState(false);
  const [isSyncModalVisible, setIsSyncModalVisible] = useState(false);
  const [isConfigModalVisible, setIsConfigModalVisible] = useState(false);
  const [data, setData] = useState([]);
  const [treeList, setTreeList] = useState([]);
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const [openPanels, setOpenPanels] = useState([]);
  const csvLinkEl = useRef();
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  // Non-operator accounts linked to TraKing only ever see / change their own
  // company's fences. Only the Nexus operator (MCID 59) can pick any company.
  const ownCompanyId =
    userInfo?.MCID !== 59 && userInfo?.NexusCompId
      ? Number(userInfo.NexusCompId)
      : null;
  const [searchTree, setSearchTree] = useState("");
  const [Reciepenttype, setReciepenttype] = useState([]);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const createAllowed = useMemo(
    () => hasPermission("GEO", "C"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("GEO", "D"),
    [reduxPermissions],
  );
  const copyAllowed = useMemo(
    () => hasPermission("GEO", "CY"),
    [reduxPermissions],
  );
  const syncAllowed = useMemo(
    () => hasPermission("GEO", "SY"),
    [reduxPermissions],
  );
  const configAllowed = useMemo(
    () => hasPermission("GEO", "CG"),
    [reduxPermissions],
  );
  const exportAllowed = useMemo(
    () => hasPermission("GEO", "EX"),
    [reduxPermissions],
  );
  // const Reciepenttype = [
  //   {
  //     name: "Consignor",
  //     value: 1,
  //     GUID: "d947bc56-14ab-4a1e-abd5-61d62d48c461",
  //   },
  //   {
  //     name: "Transporter",
  //     value: 2,
  //     GUID: "b7da9541-84c8-49a4-9fd3-550633598f5f",
  //   },
  //   {
  //     name: "Consignee",
  //     value: 3,
  //     GUID: "8c6159ce-50f1-4789-9e00-861f250c419e",
  //   },
  // ];

  const fetchAllFenceTypes = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", "geoFence/fence_types", {
        FAgentGUID: userInfo?.ECTSCompId,
      });
      setReciepenttype(data);
    } catch (error) {
      console.error("[fetchAllFenceTypes] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  function filterTree(nodes, search) {
    if (!search) return nodes;
    return nodes
      .map((node) => {
        if (node.FName?.toLowerCase().includes(search.toLowerCase())) {
          return node;
        }
        if (Array.isArray(node.FChild)) {
          const filteredChildren = filterTree(node.FChild, search);
          if (filteredChildren.length > 0) {
            return { ...node, FChild: filteredChildren };
          }
        }
        return null;
      })
      .filter(Boolean);
  }
  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedKeys(fenceList?.map((item) => item.geofence_id));
    } else {
      setSelectedKeys([]);
    }
  };

  const handleCheckboxChange = (id) => {
    if (selectedKeys.includes(id)) {
      setSelectedKeys(selectedKeys.filter((key) => key !== id));
    } else {
      setSelectedKeys([...selectedKeys, id]);
    }
  };

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const [formValues, setFormValues] = useState({
    enterFence: true,
    exitFence: false,
    exitFenceUnlocked: false,
    unlockInFence: false,
    fenceOverstay: false,
    stayTime: 0,
    speedLimitInside: false,
    speedLimitThreshold: 0,
    fenceAutomation: true,
    enterCommand: "",
    exitCommand: "",
  });

  // Dummy tree data
  const treeData = [
    {
      title: "KPM Tech Solution [106]",
      key: "0",
      children: [
        {
          title: "KPM Tech Solution [157]",
          key: "0-0",
          children: [
            { title: "KCA403V", key: "0-0-0" },
            { title: "8294830272", key: "0-0-1" },
            { title: "KSX437", key: "0-0-2" },
          ],
        },
      ],
    },
  ];

  const handleSwitchChange = (field, checked) => {
    setFormValues({ ...formValues, [field]: checked });
  };

  const handleInputChange = (field, e) => {
    setFormValues({ ...formValues, [field]: e.target.value });
  };
  const [nexusCompanyList, setNexusCompanyList] = useState([]);
  const fetchAllNexusCompany = useCallback(async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `${TRAKING_API_BASE}/traking/allCompany`,
        {
          method: "GET",
          headers: {
            "x-api-key": "trackright-secure-api-key-123",
            "Content-Type": "application/json",
          },
        },
      );

      const companies = await response.json();

      const all = companies.response || [];
      setNexusCompanyList(
        ownCompanyId
          ? all.filter((c) => Number(c.company_id) === ownCompanyId)
          : all,
      );
    } catch (error) {
      console.error("[fetchAllNexusCompany] error:", error);
    } finally {
      setLoading(false);
    }
  }, [ownCompanyId]);

  const nexusTreeList = useMemo(() => {
    const records = Array.isArray(treeList)
      ? treeList
      : treeList
        ? [treeList]
        : [];
    const groups = new Map();
    records.forEach((rec) => {
      if (!groups.has(rec.parent_id)) {
        groups.set(rec.parent_id, {
          group_id: rec.parent_id,
          group_name: rec.parent_name,
          companies: new Map(),
        });
      }
      if (rec.child_id != null) {
        groups.get(rec.parent_id).companies.set(rec.child_id, {
          company_id: rec.child_id,
          company_name: rec.child_name,
          fence_count: rec.child_fence_count ?? 0,
        });
      }
    });
    return Array.from(groups.values())
      .map((group) => {
        const companies = Array.from(group.companies.values());
        const totalFenceCount = companies.reduce(
          (sum, company) => sum + (Number(company.fence_count) || 0),
          0,
        );
        return { ...group, companies, totalFenceCount };
      })
      .sort((a, b) => b.totalFenceCount - a.totalFenceCount);
  }, [treeList]);

  const allCompaniesCount = useMemo(() => {
    const parentCount = nexusTreeList.length;

    const childCount = nexusTreeList.reduce(
      (sum, group) => sum + group.companies.length,
      0,
    );

    return parentCount + childCount;
  }, [nexusTreeList]);

  const fetchAllCompany = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllCompany");
      setCompanyList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllCompany] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAllCompany();
    fetchAllNexusCompany();
    fetchAllFenceTypes();
  }, []);
  const [search, setSearch] = useState("");
  const [search1, setSearch1] = useState("");

  const handleSearch = (val) => {
    setSearch(val);
    setCurrentPage(1); // reset pagination
  };
  const handleSearch1 = (val) => {
    setSearch1(val);
  };
  function isParentNode(nodes, guid) {
    for (const node of nodes) {
      if (node.FGUID === guid) {
        return Array.isArray(node.FChild) && node.FChild.length > 0;
      }
      if (Array.isArray(node.FChild)) {
        const found = isParentNode(node.FChild, guid);
        if (found !== null) return found;
      }
    }
    return null;
  }
  // const fetchAllFences = useCallback(async () => {
  //   const agentGUID = selectedAgent.guid || userInfo?.ECTSCompId;
  //   if (!agentGUID) return;

  //   // Determine if selected node is parent or leaf
  //   // On initial load, FType should be 0
  //   let FType = 0;
  //   if (selectedAgent.guid) {
  //     // Only use parent/leaf logic after user selects a node
  //     const parentStatus = isParentNode(
  //       Array.isArray(treeList) ? treeList : [treeList],
  //       agentGUID,
  //     );
  //     FType = parentStatus ? 0 : 1;
  //   }

  //   try {
  //     setLoading(true);
  //     const { data } = await CALL_API("POST", "geoFence/list_fences", {
  //       FAction: "QueryGISDirectlyUnderFenceByFAgentGUID",
  //       FAgentGUID: agentGUID,
  //       FIsAll: 0,
  //       FType,
  //       FKey: search,
  //       FPageSize: pageSize,
  //       FPageIndex: currentPage,
  //       FTokenID: "05463e39-8da7-479f-9377-c990bd17f76c",
  //       FTimeDifferent: 10800,
  //       FLanguage: "0",
  //     });
  //     setFenceList(data?.fences);
  //     setTotal(data?.totalRecords);
  //   } catch (error) {
  //     console.error("[fetchAllFences] error:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [selectedAgent.guid, userInfo?.ECTSCompId, pageSize, currentPage, search]); // dependency

  const fetchAllFences = useCallback(async () => {
    const agentGUID = ownCompanyId || selectedAgent.company_id;
    const companyParam =
      agentGUID && agentGUID !== "all" ? `&company_id=${agentGUID}` : "";
    // if (!agentGUID) return;

    // // Determine if selected node is parent or leaf
    // // On initial load, FType should be 0
    // let FType = 0;
    // if (selectedAgent.guid) {
    //   // Only use parent/leaf logic after user selects a node
    //   const parentStatus = isParentNode(
    //     Array.isArray(treeList) ? treeList : [treeList],
    //     agentGUID,
    //   );
    //   FType = parentStatus ? 0 : 1;
    // }

    try {
      setLoading(true);
      const response = await fetch(
        `${TRAKING_API_BASE}/traking/allFence?page=${currentPage}&limit=${pageSize}${companyParam}`,
        {
          method: "GET",
          headers: {
            "x-api-key": "trackright-secure-api-key-123",
            "Content-Type": "application/json",
          },
        },
      );
      const fences = await response.json();
      const rows = Array.isArray(fences?.response) ? fences.response : [];
      setFenceList(rows);
      setTotal(fences?.pagination?.total ?? rows.length);
    } catch (error) {
      console.error("[fetchAllFences] error:", error);
    } finally {
      setLoading(false);
    }
  }, [ownCompanyId, selectedAgent.company_id, pageSize, currentPage]); // dependency

  useEffect(() => {
    fetchAllFences();
  }, [fetchAllFences]);

  const handleDelete = async () => {
    if (selectedKeys.length === 0) {
      message.warning("Please select at least one fence to delete.");
      return;
    }
    const ids = selectedKeys.join(",");
    try {
      setLoading(true);
      const response = await fetch(
        `${TRAKING_API_BASE}/traking/deleteFence?geofence_id=${ids}`,
        {
          method: "DELETE",
          headers: {
            "x-api-key": "trackright-secure-api-key-123",
            "Content-Type": "application/json",
          },
        },
      );
      const companies = await response.json();

      if (companies?.statusCode === 200) {
        message.success("Fence(s) deleted successfully!");
        setSelectedKeys([]);
        fetchAllFences();
      } else {
        message.error("Failed to delete fence(s).");
      }
    } catch (error) {
      console.error("Error deleting Fence:", error);
      message.error("An error occurred while deleting the fence(s).");
    } finally {
      setLoading(false);
      setIsDeleteModalVisible(false); // Close the modal
    }
  };

  const handleCopy = async () => {
    if (selectedKeys.length === 0) {
      message.warning("Please select at least one fence to copy.");
      return;
    }
    if (!copyTargetAgent.guid) {
      message.warning("Please select a target agent to copy to.");
      return;
    }
    try {
      setLoading(true);
      const { data, ResponseCode } = await CALL_API(
        "POST",
        `geoFence/copy_fence`,
        {
          FGUIDs: selectedKeys.join(","),
          FFenceGUID: copyTargetAgent.type,
          FAgentGUID: copyTargetAgent.guid,
        },
      );

      if (ResponseCode === 200) {
        message.success("Fence(s) copied successfully!");
        fetchAllFences();
        setIsCopyModalVisible(false);
      } else {
        console.warn("Copy failed", data);
        message.error("Failed to copy Fence(s).");
      }
    } catch (error) {
      console.error("Error copying Fence:", error);
      message.error("An error occurred while copying the fence(s).");
    } finally {
      setLoading(false);
    }
  };
  const handleSync = async () => {
    if (selectedKeys.length === 0) {
      message.warning("Please select at least one fence to sync.");
      return;
    }
    try {
      setLoading(true);
      // Find the selected fence records
      const selectedFences = fenceList.filter((fence) =>
        selectedKeys.includes(fence.FGUID),
      );
      // Build FFenceList with correct FFenceTypeGUID for each fence
      const FFenceList = selectedFences.map((fence) => ({
        FFenceTypeGUID: fence.FFenceTypeGUID,
        FGUID: fence.FGUID,
      }));
      const { data, ResponseCode } = await CALL_API(
        "POST",
        `geoFence/sync_fence`,
        {
          FAgentGUID: selectedAgent.guid,
          FType: 0,
          FFenceList,
        },
      );

      if (ResponseCode === 200) {
        message.success("Fence(s) synced successfully!");
        setIsSyncModalVisible(false);
        fetchAllFences();
      } else {
        console.warn("Sync failed", data);
        message.error("Failed to sync Fence(s).");
      }
    } catch (error) {
      console.error("Error syncing Fence:", error);
      message.error("An error occurred while syncing the fence(s).");
    } finally {
      setLoading(false);
    }
  };
  const handleConfig = async () => {
    if (selectedKeys.length === 0) {
      message.warning("Please select at least one fence to config.");
      return;
    }
    try {
      setLoading(true);
      // Find the selected fence records
      const selectedFences = fenceList.filter((fence) =>
        selectedKeys.includes(fence.geofence_id),
      );
      // Build FFenceList with correct FFenceTypeGUID for each fence
      const FFenceList = selectedFences.map((fence) => ({
        FFenceTypeGUID: fence.FFenceTypeGUID,
        FGUID: fence.FGUID,
      }));
      const { data, ResponseCode } = await CALL_API(
        "POST",
        `geoFence/fence_config`,
        {
          FVehicleGUID: "",
          FFenceGUID: "b1a7c7ca-5696-44d4-bb6d-38c13207e4a2",
          FInAlarm: 1,
          FOutAlarm: 1,
          FStopAlarm: 1,
          FStopTime: 7200,
          FOverspeedAlarm: 1,
          FOverspeedValue: 110,
          FOutUnLockAlarm: 1,
          FUnLockFence: 1,
          FAwaken: 0,
          FOffline: 0,
          FInAwakenIns: "",
          FOutSleepIns: "",
        },
      );

      if (ResponseCode === 200) {
        message.success("Fence(s) config done successfully!");
        setIsConfigModalVisible(false);
        fetchAllFences();
      } else {
        console.warn("Config failed", data);
        message.error("Failed to config Fence(s).");
      }
    } catch (error) {
      console.error("Error in Fence config:", error);
      message.error("An error occurred while config the fence(s).");
    } finally {
      setLoading(false);
    }
  };

  // const getFenceTree = useCallback(async () => {
  //   try {
  //     setLoading(true);
  //     const { data } = await CALL_API("POST", "geoFence/tree-without-fence", {
  //       FAgentGUID: userInfo?.ECTSCompId || "",
  //     });
  //     setTreeList(data);
  //   } catch (error) {
  //     console.error("[getFenceTree] error:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, []);

  const getFenceTree = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${TRAKING_API_BASE}/traking/allCompanywithGroup`,
        {
          method: "GET",
          headers: {
            "x-api-key": "trackright-secure-api-key-123",
            "Content-Type": "application/json",
          },
        },
      );

      const companies = await response.json();
      setTreeList(companies?.response);
    } catch (error) {
      console.error("[getFenceTree] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (ownCompanyId) return; // the all-companies tree is operator-only
    getFenceTree();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function getAllPanelKeys(groups) {
    let keys = [];
    groups.forEach((group) => {
      if (Array.isArray(group.companies) && group.companies.length > 0) {
        keys.push(group.group_id); // For group panels
        keys = keys.concat(group.companies.map((c) => c.company_id));
      }
    });
    return keys;
  }

  const allPanelKeys = Array.isArray(treeList)
    ? getAllPanelKeys(treeList)
    : getAllPanelKeys([treeList]);

  const nexusAllPanelKeys = useMemo(
    () => getAllPanelKeys(nexusTreeList),
    [nexusTreeList],
  );

  // Recursive renderer for treeList
  const renderTree = (
    groups,
    setAgentFn,
    mode = "main",
    showCounts = false,
  ) => {
    return groups.map((group) => {
      const hasCompanies =
        Array.isArray(group.companies) && group.companies.length > 0;
      return (
        <Panel
          key={group.group_id}
          showArrow={hasCompanies}
          collapsible={hasCompanies ? undefined : "disabled"}
          header={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                fontWeight: 600,
                fontSize: "16px",
                color: "#2C963D",
                background: "#E8FFEC",
                padding: "4px 8px",
                borderRadius: 6,
              }}
            >
              <span style={{ display: "flex", alignItems: "center" }}>
                <GKPM style={{ marginRight: 8, flexShrink: 0 }} />
                {group.group_name}
              </span>
              {showCounts && (
                <span
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#8C8C8C",
                    background: "#fff",
                    borderRadius: 10,
                    padding: "0 8px",
                    minWidth: 20,
                    textAlign: "center",
                  }}
                >
                  {group.companies?.length || 0}
                </span>
              )}
            </div>
          }
          style={{ border: "none" }}
        >
          {hasCompanies &&
            group.companies.map((company) => {
              const isSelected =
                selectedAgent.company_id === company.company_id;
              return (
                <div
                  key={company.company_id}
                  onClick={() => {
                    setAgentFn({
                      company_id: company.company_id,
                      company_name: company.company_name,
                    });
                    setSelectedAgent({
                      company_id: company.company_id,
                      company_name: company.company_name,
                    });
                  }}
                  style={{
                    cursor: "pointer",
                    marginLeft: 20,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    color: isSelected ? "#2C963D" : "#3D3D3D",
                    padding: "6px 8px",
                    background: isSelected ? "#D4F5D4" : "transparent",
                    borderRadius: 4,
                    fontWeight: isSelected ? 600 : 400,
                  }}
                >
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <Drop style={{ marginRight: 8 }} />
                    {company.company_name}
                  </span>
                  {showCounts && (
                    <span style={{ fontSize: 12, color: "#8C8C8C" }}>
                      {company.fence_count ?? 0}
                    </span>
                  )}
                </div>
              );
            })}
        </Panel>
      );
    });
  };
  const [tableSort, setTableSort] = useState({
    field: null,
    order: null, // 'ascend' or 'descend'
  });
  const allOptions = [
    "FAgentName",
    "FName",
    "FTypeName",
    "aasset",
    "FArea",
    "FRadius",
    "FCreateTime",
  ];

  const columns = [
    {
      title: (
        <Checkbox
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => handleSelectAll(e.target.checked)}
          checked={
            fenceList.length > 0 && selectedKeys.length === fenceList.length
          }
          indeterminate={
            selectedKeys.length > 0 && selectedKeys.length < fenceList.length
          }
        />
      ),
      dataIndex: "checkbox",
      key: "checkbox",
      width: "15%",
      render: (_, record) => (
        <Checkbox
          checked={selectedKeys.includes(record.geofence_id)}
          onClick={(e) => e.stopPropagation()}
          onChange={() => handleCheckboxChange(record.geofence_id)}
        />
      ),
    },
    // {
    //   title: "Index",
    //   dataIndex: "RowNo",
    //   key: "RowNo",
    //   width: "10%",
    // },
    {
      title: "Company",
      dataIndex: "company_id",
      key: "company_id",
      width: "50%",
      sorter: (a, b) => {
        const nameA =
          nexusCompanyList?.find((item) => item?.company_id === a.company_id)
            ?.company_name || "";
        const nameB =
          nexusCompanyList?.find((item) => item?.company_id === b.company_id)
            ?.company_name || "";
        return nameA.localeCompare(nameB);
      },
      sortOrder: tableSort.field === "company_id" ? tableSort.order : null,
      render: (value) => {
        return (
          nexusCompanyList?.find(
            (item) => Number(item?.company_id) === Number(value),
          )?.company_name ?? (Number(value) === ownCompanyId ? userInfo?.COMPNAME : value)
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "20%",
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
      sortOrder: tableSort.field === "name" ? tableSort.order : null,
    },
    {
      title: "Group",
      dataIndex: "group_name",
      key: "group_name",
      width: "15%",
      sorter: (a, b) => (a.group_name || "").localeCompare(b.group_name || ""),
      sortOrder: tableSort.field === "group_name" ? tableSort.order : null,
    },
    {
      title: "Fence Style",
      dataIndex: "fence_type",
      key: "fence_type",
      width: "20%",
      sorter: (a, b) => (a.fence_type || "").localeCompare(b.fence_type || ""),
      sortOrder: tableSort.field === "fence_type" ? tableSort.order : null,
      render: (fence_type) =>
        FENCE_TYPE_LABELS[fence_type] || fence_type || "-",
    },
    // {
    //   title: "Associated Asset",
    //   dataIndex: "aasset",
    //   key: "aasset",
    //   width: "20%",
    //   sorter: (a, b) => (a.aasset || "").localeCompare(b.aasset || ""),
    //   sortOrder: tableSort.field === "aasset" ? tableSort.order : null,
    // },
    {
      title: "Area (Km²)",
      dataIndex: "area_km2",
      key: "area_km2",
      width: "20%",
      sorter: (a, b) => Number(a.area_km2) - Number(b.area_km2),
      sortOrder: tableSort.field === "area_km2" ? tableSort.order : null,
      // render: (value) => {
      //   if (!value) return "-";
      //   return (value / 1_000_000).toFixed(3);
      // },
    },
    {
      title: "Radius (Km)",
      dataIndex: "radius_km",
      key: "radius_km",
      width: "20%",
      sorter: (a, b) => Number(a.radius_km) - Number(b.radius_km),
      sortOrder: tableSort.field === "radius_km" ? tableSort.order : null,
      // render: (value) => {
      //   return (value / 1000).toFixed(2);
      // },
    },
    {
      title: "Location",
      dataIndex: "location_name",
      key: "location_name",
      width: "20%",
    },
    // {
    //   title: "Description",
    //   dataIndex: "FRemark",
    //   key: "FRemark",
    //   width: "20%",
    // },
    {
      title: "Create Time",
      dataIndex: "created_at",
      key: "created_at",
      width: "20%",
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      sortOrder: tableSort.field === "created_at" ? tableSort.order : null,
      render: (text) =>
        text ? dayjs(text).format("DD/MM/YYYY HH:mm:ss") : "-",
    },
    // {
    //   title: "Longitude",
    //   dataIndex: "coordinates",
    //   key: "longitude",
    //   width: "20%",
    //   render: (coordinates) => coordinates?.lng ?? "-",
    // },
    // {
    //   title: "Latitude",
    //   dataIndex: "coordinates",
    //   key: "latitude",
    //   width: "20%",
    //   render: (coordinates) => coordinates?.lat ?? "-",
    // },
  ];

  const prepareCSV = async () => {
    try {
      setCSVLoader(true);
      const agentGUID = ownCompanyId || selectedAgent.company_id;
      const companyParam =
        agentGUID && agentGUID !== "all" ? `&company_id=${agentGUID}` : "";
      const response = await fetch(
        `${TRAKING_API_BASE}/traking/allFence?page=${currentPage}&limit=${pageSize}${companyParam}`,
        {
          method: "GET",
          headers: {
            "x-api-key": "trackright-secure-api-key-123",
            "Content-Type": "application/json",
          },
        },
      );
      const fences = await response.json();

      if (fences?.pagination?.total > 0 || fences?.response?.length > 0) {
        setCSVList(
          fences?.response?.map((item) => ({
            Company:
              nexusCompanyList?.find((ev) => ev.company_id === item.company_id)
                ?.company_name || "-",
            Name: item.name || "-",
            // "Fence Type": item.FTypeName || "-",
            "Fence Style":
              FENCE_TYPE_LABELS[item.fence_type] || item.fence_type || "-",
            // "Associated Asset": item.aasset || "-",
            "Area (Km²)": item.area_km2 || "-",
            "Radius (Km)": item.radius_km || "0.00",
            Location: item.location_name || "-",
            // Description: item.FRemark || "-",
            "Create Time": item.created_at
              ? dayjs(item.created_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
            Longitude: item?.coordinates?.lng || "-",
            Latitude: item?.coordinates?.lat || "-",
          })),
        );

        setTimeout(() => {
          csvLinkEl.current?.link?.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("CSV export error -->", error);
    } finally {
      setCSVLoader(false);
    }
  };
  function getCompanyNameByFGUID(nodes, guid) {
    for (const node of nodes) {
      if (node.FGUID === guid) return node.FName;
      if (Array.isArray(node.FChild)) {
        const found = getCompanyNameByFGUID(node.FChild, guid);
        if (found) return found;
      }
    }
    return "";
  }
  const handleSortOptionsChange = (checkedValues) => {
    setSortFields(checkedValues);
  };
  const onCheckAllChange = (e) => {
    const isChecked = e.target.checked;
    setSortFields(isChecked ? allOptions : []);
  };
  // const content = (
  //   <Styledashboard>
  //     <div className="checkbox_group_container">
  //       <Checkbox
  //         indeterminate={
  //           sortFields.length > 0 && sortFields.length < allOptions.length
  //         }
  //         onChange={onCheckAllChange}
  //         checked={sortFields.length === allOptions.length}
  //       >
  //         All
  //       </Checkbox>

  //       <Checkbox.Group value={sortFields} onChange={handleSortOptionsChange}>
  //         <div className="checkbox_group_container">
  //           <Checkbox value="FAgentName">Company</Checkbox>
  //           <Checkbox value="FName">Name</Checkbox>
  //           <Checkbox value="FTypeName">Fence Type</Checkbox>
  //           <Checkbox value="aasset">Associated Asset</Checkbox>
  //           <Checkbox value="FArea">Area</Checkbox>
  //           <Checkbox value="FRadius">Radius</Checkbox>
  //           <Checkbox value="FCreateTime">Create Time</Checkbox>
  //         </div>
  //       </Checkbox.Group>
  //     </div>
  //   </Styledashboard>
  // );
  return (
    <Styledashboard>
      <div style={{ padding: "16px", background: "#f0f2f5" }}>
        <Row gutter={[0, 16]} style={{ margin: 0 }}>
          {/* Left White Box */}
          {userInfo?.MCID === 59 && userInfo?.SYSADM === true && (
            <Col
              style={{
                flex: "0 0 350px",
                maxWidth: 350,
                minWidth: 350,
                paddingRight: 0,
                paddingLeft: 0,
              }}
            >
              {" "}
              <Card
                className="container_scrollable"
                style={{
                  borderRadius: "12px",
                  height: "100%",
                  width: "100%",
                  marginRight: "20px",
                }}
              >
                <div>
                  {/* Search bar */}
                  <Input
                    className="custom-search "
                    allowClear
                    placeholder="Enter keywords"
                    value={searchTree}
                    prefix={
                      <IntelSearch
                        style={{
                          cursor: "pointer",
                        }}
                      />
                    }
                    onChange={(e) => setSearchTree(e.target.value)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  />
                  <br />
                  {/* All Companies (default selection) */}
                  <div
                    onClick={() =>
                      setSelectedAgent({
                        company_id: "all",
                        company_name: "All Companies",
                      })
                    }
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      fontWeight: 600,
                      fontSize: "16px",
                      color: "#2C963D",
                      background:
                        selectedAgent.company_id === "all"
                          ? "#D4F5D4"
                          : "#E8FFEC",
                      padding: "4px 8px",
                      borderRadius: 6,
                      marginBottom: 8,
                    }}
                  >
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <GKPM style={{ marginRight: 8, flexShrink: 0 }} />
                      All Companies
                    </span>
                    <span
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#8C8C8C",
                        background: "#fff",
                        borderRadius: 10,
                        padding: "0 8px",
                        minWidth: 20,
                        textAlign: "center",
                      }}
                    >
                      {allCompaniesCount}
                    </span>
                  </div>
                  {/* Dropdown items */}
                  <Collapse
                    bordered={false}
                    expandIconPosition="end"
                    defaultActiveKey={nexusAllPanelKeys}
                    expandIcon={({ isActive }) => (
                      <GArrow
                        size={18}
                        style={{
                          transform: isActive
                            ? "rotate(0deg)"
                            : "rotate(180deg)",
                          transition: "transform 0.2s",
                        }}
                      />
                    )}
                  >
                    {renderTree(nexusTreeList, setSelectedAgent, "main", true)}
                  </Collapse>
                </div>
              </Card>
            </Col>
          )}
          {/* Right White Box */}
          <Col
            style={{ flex: 1, minWidth: 0, paddingLeft: 15, paddingRight: 0 }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <Card
                style={{
                  borderRadius: "12px",
                  height: "100%",
                  width: "100%", // lock width to col size
                  overflow: "hidden", // prevent overflow messing layout
                }}
              >
                <div className="container_for_header_subtwo">
                  <Icon /> <p className="title">{userInfo?.COMPNAME}</p>
                  {/* <Tooltip title={!createAllowed ? "No permission" : ""}> */}
                  <ButtonFilled
                    type="primary"
                    // disabled={!createAllowed}
                    onClick={() =>
                      navigate("/NexusGeoDetails", {
                        state: {
                          mode: "add",
                          company_id:
                            ownCompanyId ||
                            (selectedAgent.company_id !== "all"
                              ? selectedAgent.company_id
                              : undefined),
                        },
                      })
                    }
                  >
                    + Add Fence
                  </ButtonFilled>
                  {/* </Tooltip> */}
                </div>
                <br />
                <div className="container_for_header_subtwo">
                  {/* <Tooltip title={!deleteAllowed ? "No permission" : ""}> */}
                  <GDelete
                    style={
                      {
                        // cursor: deleteAllowed ? "pointer" : "not-allowed",
                      }
                    }
                    onClick={() => {
                      // if (!deleteAllowed) return;
                      if (selectedKeys.length === 0) {
                        message.warning(
                          "Please select a geofence before attempting to delete.",
                        );
                        return;
                      }
                      setIsDeleteModalVisible(true);
                    }}
                  />
                  {/* </Tooltip> */}
                  {/* <Tooltip title={!configAllowed ? "No permission" : ""}>
                    <GConfig
                      style={{
                        cursor: configAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!configAllowed) return;
                        if (selectedKeys.length === 0) {
                          message.warning(
                            "Please select a geofence before attempting to config.",
                          );
                          return;
                        }
                        setIsConfigModalVisible(true);
                      }}
                    />
                  </Tooltip>
                  <Tooltip title={!syncAllowed ? "No permission" : ""}>
                    <GSync
                      style={{
                        cursor: syncAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!syncAllowed) return;
                        if (selectedKeys.length === 0) {
                          message.warning(
                            "Please select a geofence before attempting to sync.",
                          );
                          return;
                        }
                        setIsSyncModalVisible(true);
                      }}
                    />
                  </Tooltip>
                  <Tooltip title={!copyAllowed ? "No permission" : ""}>
                    <GCopy
                      style={{
                        cursor: copyAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!copyAllowed) return;
                        if (selectedKeys.length === 0) {
                          message.warning(
                            "Please select a geofence before attempting to copy.",
                          );
                          return;
                        }
                        setIsCopyModalVisible(true);
                      }}
                    />
                  </Tooltip> */}
                  {/* <Input
                    className="custom-search"
                    style={{ width: 350 }}
                    placeholder="Search"
                    allowClear
                    prefix={
                      <IntelSearch
                        style={{
                          cursor: "pointer",
                        }}
                      />
                    }
                    value={search}
                    onChange={(e) => handleSearch(e.target.value)} // triggers as you type
                    onSearch={handleSearch} // still works when pressing Enter or clicking Search icon
                  /> */}
                  {/* <GFilter style={{ cursor: "pointer" }} /> */}
                  {/* <Popover content={content} trigger="click">
                    <img
                      src={GSort}
                      alt="Sort"
                      style={{
                        cursor: "pointer",
                        marginRight: "30px",
                        backgroundColor: "#EBF7ED",
                        borderRadius: "6px",
                      }}
                      onClick={(e) => e.preventDefault()}
                    />
                  </Popover>{" "} */}
                  <Spin spinning={CSVLoader}>
                    <GExport
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        // if (!exportAllowed) return;
                        prepareCSV();
                      }}
                    />
                  </Spin>
                  <CSVLink
                    data={CSVList}
                    filename={"GeoFence.csv"}
                    asyncOnClick={true}
                    ref={csvLinkEl}
                  />
                </div>

                {/* Table with scroll */}
                <div className="scrollablle_container_two">
                  <Spin spinning={loading}>
                    {(total > 0 || fenceList.length > 0) && (
                      <StyledTable
                        className="mt-4"
                        dataSource={fenceList}
                        columns={columns}
                        pagination={false}
                        style={{ cursor: "pointer" }}
                        onRow={(record) => ({
                          onClick: () => {
                            navigate(`/NexusGeoDetails`, {
                              state: {
                                ...record,
                                mode: "view",
                              },
                            });
                          },
                        })}
                        onChange={(pagination, filters, sorter) => {
                          setTableSort({
                            field: sorter.field,
                            order: sorter.order,
                          });
                        }}
                        rowKey="geofence_id"
                      />
                    )}
                    <ReusablePagination
                      pageSize={pageSize}
                      handlePageSizeChange={handlePageSizeChange}
                      currentPage={currentPage}
                      total={total}
                      handlePageChange={handlePageChange}
                    />
                  </Spin>
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
      <UIModal
        width={500}
        open={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)} // Close the modal
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <GeoDelete />
          <h3>Delete Geofence?</h3>
          <p>
            This action will permanently delete the selected Geofence. Do you
            want to proceed?
          </p>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              onClick={handleDelete} // Call the delete function
              loading={loading}
            >
              Confirm
            </ButtonFilled>
            <Buttontransparent
              onClick={() => setIsDeleteModalVisible(false)} // Close the modal
            >
              Cancel
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <UIModal
        width={500}
        open={isSyncModalVisible}
        onClose={() => setIsSyncModalVisible(false)} // Close the modal
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h6>
            Are you sure to synchronize the selected{" "}
            <b>
              [{selectedKeys.length} fence{selectedKeys.length > 1 ? "s" : ""}]
            </b>{" "}
            to the subsidiary of <b>[{selectedAgent?.name || "----"}]</b>?
          </h6>

          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              onClick={handleSync} // Call the sync function
              loading={loading}
            >
              Confirm
            </ButtonFilled>
            <Buttontransparent
              onClick={() => setIsSyncModalVisible(false)} // Close the modal
            >
              Cancel
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <Modal
        title="Copy Geofence"
        open={isCopyModalVisible}
        onCancel={() => setIsCopyModalVisible(false)}
        footer={[
          <Buttontransparent onClick={() => setIsCopyModalVisible(false)}>
            Cancel
          </Buttontransparent>,
          <ButtonFilled key="save" type="primary" onClick={handleCopy}>
            Copy
          </ButtonFilled>,
        ]}
        width={500} // adjust modal size
      >
        <Card style={{ borderRadius: "12px", height: "100%" }}>
          <div>
            <b>Choose where you want to paste fence</b>
            {copyTargetAgent.guid && copyTargetAgent.name && (
              <div style={{ marginTop: 16, fontWeight: 500, color: "#2C963D" }}>
                Paste the fence to:{" "}
                <span style={{ color: "#222" }}>
                  {getCompanyNameByFGUID(treeList, copyTargetAgent.guid)} →{" "}
                  {copyTargetAgent.name}
                </span>
              </div>
            )}
            {/* Search bar */}
            <Search
              className="select_icon_dropdown"
              style={{ width: "100%" }}
              placeholder="Search"
              allowClear
              value={search1}
              onChange={(e) => handleSearch1(e.target.value)} // triggers as you type
              onSearch={handleSearch1} // still works when pressing Enter or clicking Search icon
            />

            <br />

            {/* Dropdown items */}
            {loading ? (
              <Spin />
            ) : (
              <Collapse
                bordered={false}
                expandIconPosition="end"
                expandIcon={({ isActive }) => (
                  <GArrow
                    size={18}
                    style={{
                      transform: isActive ? "rotate(0deg)" : "rotate(180deg)",
                      transition: "transform 0.2s",
                    }}
                  />
                )}
              >
                {Array.isArray(treeList)
                  ? renderTree(treeList, setCopyTargetAgent, 0, "copy")
                  : renderTree([treeList], setCopyTargetAgent, 0, "copy")}
              </Collapse>
            )}
          </div>
        </Card>
      </Modal>
      <Modal
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontWeight: 600 }}>Geofence Configuration</span>
            <span style={{ fontSize: "14px", color: "#6B7280" }}>
              Selected: {selectedFences.length} Fences, {selectedDevices.length}{" "}
              Devices
            </span>
          </div>
        }
        open={isConfigModalVisible}
        onCancel={() => setIsConfigModalVisible(false)}
        footer={[
          <Buttontransparent
            key="cancel"
            onClick={() => setIsConfigModalVisible(false)}
          >
            Cancel
          </Buttontransparent>,
          <ButtonFilled key="save" type="primary" onClick={handleConfig}>
            Update
          </ButtonFilled>,
        ]}
        width={960}
        bodyStyle={{ padding: "20px" }}
      >
        <div style={{ display: "flex", gap: "20px" }}>
          {/* Left Panel */}
          <div style={{ flex: 1 }}>
            <Input.Search
              placeholder="Search"
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
              allowClear
              style={{ marginBottom: "12px", borderRadius: "8px" }}
            />
            <div
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                padding: "10px",
                height: "400px",
                overflowY: "auto",
                background: "#fff",
              }}
            >
              <Tree
                treeData={treeData}
                defaultExpandAll
                selectedKeys={selectedFences}
                onSelect={(selectedKeys) => setSelectedFences(selectedKeys)}
                showIcon
              />
            </div>
          </div>

          {/* Right Panel */}
          <div style={{ flex: 1 }}>
            <div
              style={{
                marginBottom: "16px",
                fontSize: "14px",
                color: "#374151",
              }}
            >
              <b>Geofence Alarm Configuration</b>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <span>Enter fence</span>
              <Switch
                checked={formValues.enterFence}
                onChange={(checked) =>
                  handleSwitchChange("enterFence", checked)
                }
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <span>Exit fence</span>
              <Switch
                checked={formValues.exitFence}
                onChange={(checked) => handleSwitchChange("exitFence", checked)}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <span>Exit fence - unlocked</span>
              <Switch
                checked={formValues.exitFenceUnlocked}
                onChange={(checked) =>
                  handleSwitchChange("exitFenceUnlocked", checked)
                }
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <span>Unlock in fence</span>
              <Switch
                checked={formValues.unlockInFence}
                onChange={(checked) =>
                  handleSwitchChange("unlockInFence", checked)
                }
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <span>Fence overstay</span>
              <Switch
                checked={formValues.fenceOverstay}
                onChange={(checked) =>
                  handleSwitchChange("fenceOverstay", checked)
                }
              />
            </div>

            <div
              style={{
                display: "flex",
                gap: "12px",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <span style={{ width: "120px" }}>Stay time (min)</span>
              <Input
                type="number"
                value={formValues.stayTime}
                onChange={(e) => handleInputChange("stayTime", e)}
                style={{ borderRadius: "8px", width: "100px" }}
              />
            </div>

            <div
              style={{
                display: "flex",
                gap: "12px",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <Switch
                checked={formValues.speedLimitInside}
                onChange={(checked) =>
                  handleSwitchChange("speedLimitInside", checked)
                }
              />
              <span style={{ flex: 1 }}>Speed limit inside the fence</span>
              <Input
                type="number"
                value={formValues.speedLimitThreshold}
                onChange={(e) => handleInputChange("speedLimitThreshold", e)}
                placeholder="km/h"
                style={{ width: "120px", borderRadius: "8px" }}
              />
            </div>

            <div
              style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <Switch
                checked={formValues.fenceAutomation}
                onChange={(checked) =>
                  handleSwitchChange("fenceAutomation", checked)
                }
              />
              <span>Fence Automation Instructions</span>
            </div>

            <div style={{ marginBottom: "12px" }}>
              <label style={{ fontSize: "14px", color: "#374151" }}>
                Enter the area to sending commands
              </label>
              <TextArea
                rows={2}
                value={formValues.enterCommand}
                onChange={(e) => handleInputChange("enterCommand", e)}
                style={{ borderRadius: "8px", marginTop: "4px" }}
              />
            </div>

            <div>
              <label style={{ fontSize: "14px", color: "#374151" }}>
                Sending commands out of the area
              </label>
              <TextArea
                rows={2}
                value={formValues.exitCommand}
                onChange={(e) => handleInputChange("exitCommand", e)}
                style={{ borderRadius: "8px", marginTop: "4px" }}
              />
            </div>
          </div>
        </div>
      </Modal>
    </Styledashboard>
  );
};

export default NexusGeoFence;
